import paintingWorks from '../../assets/images/painting_works.svg';
import paintingWheel from '../../assets/images/painting_wheel.svg';
import glassTinting from '../../assets/images/glass_tinting.svg';

export enum CategoryTypes {
	PaintingWorks = 'PaintingWorks',
	PaintingWheels = 'PaintingWheels',
	GlassTinting = 'GlassTinting',
}

export const CategoryNames = {
	[CategoryTypes.PaintingWorks]: 'Покрасочные работы',
	[CategoryTypes.PaintingWheels]: 'Покраска колес',
	[CategoryTypes.GlassTinting]: 'Тонировка стёкл',
};

export const CategoryImages = {
	[CategoryTypes.PaintingWorks]: paintingWorks,
	[CategoryTypes.PaintingWheels]: paintingWheel,
	[CategoryTypes.GlassTinting]: glassTinting,
};

export const categories = [
	{
		id: 0,
		type: CategoryTypes.PaintingWorks,
		name: CategoryNames[CategoryTypes.PaintingWorks],
		image: CategoryImages[CategoryTypes.PaintingWorks],
	},
	{
		id: 1,
		type: CategoryTypes.PaintingWheels,
		name: CategoryNames[CategoryTypes.PaintingWheels],
		image: CategoryImages[CategoryTypes.PaintingWheels],
	},
	{
		id: 2,
		type: CategoryTypes.GlassTinting,
		name: CategoryNames[CategoryTypes.GlassTinting],
		image: CategoryImages[CategoryTypes.GlassTinting],
	},
];

export const getCategoryByType = (type: CategoryTypes | null) => {
	return categories.find((category) => category.type === type);
};
